import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";

// Lightweight scroll reveal: fade + rise, fires once at 15% visibility.
export default function Reveal({ children, className = "", delay = 0, testId }) {
  return (
    <motion.div
      className={className}
      data-testid={testId}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}
